import { required, email, ValidationRule } from 'vuelidate/lib/validators';

export interface RecoverPasswordConfig {
  data: {
    email: string | null;
  };
  html: {
    default: {
      header: {
        title: string;
        text: string;
      };
      button: {
        text: string;
        icon: null;
      };
    };
    success: {
      header: {
        title: string;
        text: null;
      };
    };
    input: {
      model: string;
      type: string;
      placeholder: string;
      autocomplete?: string;
    }[];
  };
  validations: {
    email: {
      required: () => ValidationRule;
      email: () => ValidationRule;
    };
  };
}

export default {
  data: {
    email: null,
  },
  html: {
    default: {
      header: {
        title: 'Unustasid salasõna?',
        text: 'Nurodykite el. pašto adresą, kuriuo atsiųsime slaptažodžio pakeitimo nuorodą.',
      },
      button: {
        text: 'Siųsti',
        icon: null,
      },
    },
    success: {
      header: {
        title: 'Slaptažodžio pakeitimo nuoroda Jums buvo išsiųsta į nurodytą el. pašto adresą. Pasitikrinkite savo el. pašto dėžutę.',
        text: null,
      },
    },
    input: [
      {
        model: 'email',
        type: 'email',
        placeholder: 'El. paštas',
        focus: true,
        autocomplete: 'email',
      },
    ],
  },
  validations: {
    email: {
      required,
      email,
    },
  },
};
